/**
 * Sort By Menu
 */

/**
 * TODO:
 * - Resolve the following warning
 * "margin" styles cannot be used to apply padding between the popper and its reference element or boundary. To replicate margin, use the `offset` modifier, as well as the `padding` option in the `preventOverflow` and `flip` modifiers.
 * - Hover font color needs to worked on.
 */

import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  filter,
  Flex,
  Button,
  Box,
} from "@chakra-ui/react";
import {
  defaultJobPayload,
  jobPayloadState,
  savedJobsSortByState,
  selectedSortByState,
} from "_state/atoms/AppAtoms";
import { aiScoresGroup, preferenceScoreGroup } from "config/Consts";
import _ from "lodash";
import { useGetUserProfileQuery } from "queries";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { OutlineButton } from "../HJSButton";
import { useLocation } from "react-router-dom";

interface ISortByProps {
  protectedFeatures: string[];
}

interface IFilterState {
  data: any;
  // order: number[];
}
interface ISortBy {
  reset: boolean;
  setReset: (arg?: any) => void;
}

const FilterActions = {
  UP: "UP",
  DOWN: "DOWN",
};

const SortBy: FC<ISortBy> = ({ reset, setReset }) => {
  const { data: userData } = useGetUserProfileQuery();
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";

  const [payload, setPayload] = useRecoilState(jobPayloadState);

  const { aiScore, preferenceScore, postedDate, distance } = payload;

  // const countRef = useRef<number>(0);

  const sortByFilter = useMemo(() => {
    const filterArr = ["Location", "Posted Date"];
    // isJobSearch && filterArr.push("Date Posted");
    preferenceScoreGroup.includes(userData?.group) &&
      filterArr.unshift("Preference Score");
    aiScoresGroup.includes(userData?.group) && filterArr.unshift("AI Score");
    return filterArr;
  }, [userData]);

  const [order, setOrder] = useState<string[]>([]);

  const [filters, setFilters] = useState<IFilterState>({
    data: sortByFilter,
  });

  const [selectedSortBy, setSelectedSortBy] =
    useRecoilState(selectedSortByState);
  const [savedJobsSortBy, setSavedSortBy] =
    useRecoilState(savedJobsSortByState);

  useEffect(() => {
    if (reset) {
      setFilters(() => ({
        data: sortByFilter,
      }));
      setPayload({ ...defaultJobPayload, sort: sortByFilter });
      setOrder(sortByFilter);
    }
  }, [reset]);

  useEffect(() => {
    setFilters((prev) => ({
      data: sortByFilter,
      order: new Array(sortByFilter.length).fill(-1),
    }));
    setPayload((prev) => ({ ...prev, sort: [...sortByFilter] }));
  }, [sortByFilter]);

  // no  filter is on by default on saved job page
  // useEffect(() => {
  //   !isJobSearch && setSelectedSortBy([]);
  // }, []);

  useEffect(() => {
    setOrder(sortByFilter);
  }, [sortByFilter]);

  const handleFilterOrder = (action: string, filter: string): void => {
    const { UP, DOWN } = FilterActions;
    const newOrder = [...filters.data];
    const foundIdx = filters.data.indexOf(filter) as number;
    const prev = newOrder[foundIdx - 1];
    const next = newOrder[foundIdx + 1];

    reset && setReset(false);
    switch (action) {
      case UP:
        newOrder[foundIdx - 1] = filter;
        newOrder[foundIdx] = prev;
        // setOrder(newOrder);
        setFilters({ data: newOrder });
        break;
      case DOWN:
        newOrder[foundIdx + 1] = filter;
        newOrder[foundIdx] = next;
        // setOrder(newOrder);
        setFilters({ data: newOrder });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const { data } = filters;
    const temp = [...order];

    data?.forEach((el: any) => {
      !temp.includes(el) && temp.push(el);
    });
    setFilters({ data: temp });
    order?.length > 0 && isJobSearch && setSelectedSortBy(temp);
  }, [order]);

  return (
    <Menu
      matchWidth={true}
      gutter={0}
      closeOnSelect={false}
      closeOnBlur={true}
      onClose={() => setFilters({ data: order })}
    >
      {({ isOpen, onClose }) => (
        <>
          <MenuButton
            as={OutlineButton}
            fontSize={{ base: 14, md: 16 }}
            rightIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            width={48}
            borderBottomLeftRadius={isOpen ? "initial" : ".375rem"}
            borderBottomRightRadius={isOpen ? "initial" : ".375rem"}
            background="hjsOpaqueBlackAlpha"
            _active={{ background: "hjsOpaqueBlackAlpha" }}
          >
            <Text fontWeight="700">Sort By</Text>
          </MenuButton>
          <MenuList
            minW="initial"
            bgColor="hjsOpaqueBlackAlpha"
            px={3}
            border="2px solid"
            borderColor="teal.900"
            borderTopRightRadius="initial"
            borderTopLeftRadius="initial"
            borderTop="initial"
          >
            {filters?.data?.map((filter: string, index: number) => (
              <MenuItem
                key={filter}
                borderBottom={
                  index !== filters?.data?.length - 1 ? "1px solid" : "none"
                }
                borderBottomColor="teal.900"
                onClick={() =>
                  !isJobSearch &&
                  !savedJobsSortBy.includes(filter) &&
                  setSavedSortBy((prev) => [...prev, filter])
                }
                bgColor={isJobSearch ? "hjsOpaqueBlackAlpha !important" : ""}
                className={`flex justify-between ${
                  isJobSearch ? `cursor-[initial]` : `cursor-pointer`
                }`}
              >
                <Text
                  fontSize={{ base: 14, md: 16 }}
                  fontWeight="700"
                  // color={order.includes(filter) ? "white" : "teal.900"}
                >
                  {/* {order?.length > 0 &&
                    isJobSearch &&
                    order.includes(filter) && */}
                  {(index + 1).toString().concat(" - ")}
                  {filter}
                </Text>
                {isJobSearch && (
                  <Flex direction="column" alignItems="center">
                    {index > 0 && (
                      <Box
                        as="button"
                        p={1}
                        cursor="pointer"
                        borderRadius="md"
                        _hover={{ bg: "gray.300" }}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleFilterOrder(FilterActions.UP, filter);
                        }}
                      >
                        <ChevronUpIcon />
                      </Box>
                    )}
                    {index < filters?.data?.length - 1 && (
                      <Box
                        as="button"
                        p={1}
                        cursor="pointer"
                        borderRadius="md"
                        _hover={{ bg: "gray.300" }}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleFilterOrder(FilterActions.DOWN, filter);
                        }}
                      >
                        <ChevronDownIcon />
                      </Box>
                    )}
                  </Flex>
                )}
              </MenuItem>
            ))}
            {/* <Flex justifyContent="center"> */}
            {isJobSearch && (
              <Button
                bgColor="teal.600 "
                // border="2px solid teal"
                color="white"
                w="full"
                mt={1}
                onClick={() => {
                  setOrder(() => {
                    return filters.data;
                  });
                  setPayload((prev: any) => ({
                    ...prev,
                    sort: filters.data,
                  }));
                  onClose();
                }}
                _hover={{ bgColor: "teal.500" }}
              >
                Done
              </Button>
            )}
            {/* </Flex> */}
          </MenuList>
        </>
      )}
    </Menu>
  );
};

export default SortBy;
